/*
 * Copyright (c) 2023
 *
 * The source code and all documents related to the source code ("Material") are owned by
 * Frictionless Systems, LLC.
 *
 * The Material contains trade secrets, proprietary information, and confidential information.
 * No part of the Material may be used, copied, reproduced, modified, published, distributed, or
 * disclosed in any way without Frictionless Systems, LLC’s express prior written permission.
 *
 * The Material may be protected under patent, trademark, copyright, or trade secret laws.  No
 * license is granted to you by disclosure or delivery of the Materials.  Any license must be
 * express and approved by Frictionless Systems, LLC in writing.
 *
 * “Frictionless Systems” and “Impulse” are registered trademarks of Frictionless Systems, LLC.
 */

package systems.frictionless.impulse.browser

import systems.frictionless.impulse.rest.client.model.RestResponse

object ErrorTranslation {
    /**
     * @param failure The failure that occurred
     * @param handler Type-specific handler for the error.
     */
    fun <ResponseType> translate(
        failure: RestResponse.Failure<ResponseType>,
        handler: (RestResponse.Failure.Server<ResponseType>) -> String = {
            "Server error: ${it.serverError.errorMessage}"
        }
    ): String {
        return when (failure) {
            is RestResponse.Failure.Client -> "An error occurred"
            is RestResponse.Failure.Connection -> "There was an error connecting to the server; check your network connection and try again."
            is RestResponse.Failure.Server -> handler(failure)
        }
    }
}
